import React from 'react';

const ServicesComponent = () => {
    return (
        <section className="backlight-top">
            <div className="stg-row infocolors-section-title">
                <div className="stg-col-8 stg-offset-2">
                    <div className="align-center">
                        <h2 data-appear="fade-up" data-unload="fade-up">Our Services</h2>
                        <p className="infocolors-large-text" data-appear="fade-up" data-unload="fade-up" data-delay="100">We offer a wide range of creative services to help individuals and businesses of all sizes achieve their goals. Our services include:</p>
                    </div>
                </div>
            </div>
            <div className="infocolors-detailed-list-wrap" data-appear="fade-up" data-unload="fade-up" data-delay="200">
                <ul className="infocolors-detailed-list">
                    <li>
                        <div className="infocolors-detailed-list-title">
                            <h4>Event Coverage & Videography<span className="infocolors-accent">.</span></h4>
                        </div>
                        <div className="infocolors-detailed-list-description">
                            <p>Don't miss a moment. We specialize in dynamic and comprehensive coverage of fashion shows, concerts, corporate events, and special occasions, ensuring every detail is beautifully documented.</p>
                        </div>
                        <div className="infocolors-detailed-list-button">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="/services"><span className="sr-only">View Service Details</span></a>
                    </li>
                    <li>
                        <div className="infocolors-detailed-list-title">
                            <h4>Cinematography<span className="infocolors-accent">.</span></h4>
                        </div>
                        <div className="infocolors-detailed-list-description">
                            <p>Tell your story with cinematic flair. From music videos to short films, our cinematography services bring your creative vision to life with stunning visuals and compelling narratives.</p>
                        </div>
                        <div className="infocolors-detailed-list-button">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="/services"><span className="sr-only">View Service Details</span></a>
                    </li>
                    <li>
                        <div className="infocolors-detailed-list-title">
                            <h4>Professional Content Creation<span className="infocolors-accent">.</span></h4>
                        </div>
                        <div className="infocolors-detailed-list-description">
                            <p>Engage your audience with captivating content. We craft high-impact videos and visuals tailored for social media, websites, and digital campaigns that resonate with your target market.</p>
                        </div>
                        <div className="infocolors-detailed-list-button">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="/services"><span className="sr-only">View Service Details</span></a>
                    </li>
                    <li>
                        <div className="infocolors-detailed-list-title">
                            <h4>Ads & Professional Content for Businesses<span className="infocolors-accent">.</span></h4>
                        </div>
                        <div className="infocolors-detailed-list-description">
                            <p>Boost your brand with visually powerful advertising. We create compelling promotional videos, branding content, and commercial ads that elevate your business and connect with customers.</p>
                        </div>
                        <div className="infocolors-detailed-list-button">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="/services"><span className="sr-only">View Service Details</span></a>
                    </li>
                    <li>
                        <div className="infocolors-detailed-list-title">
                            <h4>Professional Video Editing<span className="infocolors-accent">.</span></h4>
                        </div>
                        <div className="infocolors-detailed-list-description">
                            <p> Transform raw footage into polished masterpieces. Our expert video editors refine, enhance, and assemble your visuals, ensuring a seamless and professional final product.</p>
                        </div>
                        <div className="infocolors-detailed-list-button">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="/services"><span className="sr-only">View Service Details</span></a>
                    </li>
                      <li>
                        <div className="infocolors-detailed-list-title">
                            <h4>Photography & Photo Editing<span className="infocolors-accent">.</span></h4>
                        </div>
                        <div className="infocolors-detailed-list-description">
                            <p> Capture moments with precision and artistry. From event and studio photography to real estate and product shots, we deliver high-quality images with professional post-production.</p>
                        </div>
                        <div className="infocolors-detailed-list-button">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </div>
                        <a href="/services"><span className="sr-only">View Service Details</span></a>
                    </li>
                </ul>
            </div>
            <div className="align-center stg-top-gap" data-appear="fade-up" data-unload="zoom-out" data-delay="100">
                <a href="services.html" className="infocolors-button">Explore All Services</a>
            </div>
        </section>
    );
};

export default ServicesComponent;
